<parkour-image [src]="content.content.image.file" />
